import { useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * 기간 필터 관리를 담당하는 커스텀 훅
 * @returns {object} - 기간 필터 관련 상태와 함수들
 */
export const usePeriodFilter = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState(7); // 기본값: 1주일
  const { t } = useTranslation();

  const periodOptions = [
    { value: 1, label: t('periods.today') },
    { value: 7, label: t('periods.oneWeek') },
    { value: 30, label: t('periods.oneMonth') },
    { value: null, label: t('periods.all') }
  ];

  /**
   * 메뉴 열기
   * @param {Event} event - 클릭 이벤트
   */
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  /**
   * 메뉴 닫기
   */
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  /**
   * 기간 선택
   * @param {number|null} value - 선택된 기간 값
   * @param {function} onPeriodChange - 기간 변경 콜백 함수
   */
  const handlePeriodSelect = (value, onPeriodChange) => {
    setSelectedPeriod(value);
    setAnchorEl(null);
    if (onPeriodChange) {
      onPeriodChange(value);
    }
  };

  /**
   * 현재 선택된 기간 라벨 가져오기
   * @returns {string} - 현재 기간 라벨
   */
  const getCurrentPeriodLabel = () => {
    const option = periodOptions.find(opt => opt.value === selectedPeriod);
    return option ? option.label : '전체';
  };

  return {
    anchorEl,
    selectedPeriod,
    periodOptions,
    handleMenuOpen,
    handleMenuClose,
    handlePeriodSelect,
    getCurrentPeriodLabel
  };
}; 